module.exports = __webpack_public_path__ + "img/backgroundSixth.b484dd0c.png";